import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const PaymentLogServices = {
  create: async (data) => {
    const response = await apiService.post(
      `/${slug}/supplier-payments/create`,
      data
    );
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get(`/${slug}/supplier-payments/getall`);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/supplier-payments/get/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(
      `/${slug}/supplier-payments/update/${id}`,
      data
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/${slug}/supplier-payments/delete/${id}`
    );
    return response.data;
  },
};

export default PaymentLogServices;
